<template>
  <v-row row wrap>
    <v-col class="col-12 mb-3 level-bar-container">
      <div>
        <GridLevelButton
          v-if="levels"
          title="Unstable"
          :color="colorVeryLow"
          :selected="levels[0].selected"
          :level="levels[0].id"
          @click="toggleLevel"
        ></GridLevelButton>

        <GridLevelButton
          v-if="levels"
          :color="colorLow"
          :selected="levels[1].selected"
          :level="levels[1].id"
          @click="toggleLevel"
        ></GridLevelButton>

        <GridLevelButton
          v-if="levels"
          :color="colorNeutral"
          :selected="levels[2].selected"
          :level="levels[2].id"
          @click="toggleLevel"
        ></GridLevelButton>

        <GridLevelButton
          v-if="levels"
          :color="colorHigh"
          :selected="levels[3].selected"
          :level="levels[3].id"
          @click="toggleLevel"
        ></GridLevelButton>

        <GridLevelButton
          v-if="levels"
          title="Stable"
          :color="colorVeryHigh"
          :selected="levels[4].selected"
          :level="levels[4].id"
          @click="toggleLevel"
        ></GridLevelButton>
      </div>
    </v-col>
  </v-row>
</template>

<script>
import { mapGetters } from "vuex";

import {
  GET_STABILITY_PARAMS,
  GET_STABILITY_REFRESH_MAP,
  SAVE_PREFERENCES,
} from "@/store/actions.type";
import { MODULE_PREFIX_GRIDS, MODULE_PREFIX_USER } from "@/store";
import {
  buildPreferences,
  getLevelsFromPreferences,
} from "@/services/grids/stability.service";
import { GRIDS_STABILITY_COLORS } from "@/common/constants/grids";
import { EVENT_ACTIONS, EVENT_CATEGORIES } from "@/common/constants/analytics";

export default {
  name: "StabilityLevelBar",
  components: {
    GridLevelButton: () => import("@/components/grids/GridLevelButton"),
  },
  data: () => ({
    levels: null,
  }),
  mounted() {
    this.getPrefs();
  },
  computed: {
    ...mapGetters({
      preferences: MODULE_PREFIX_USER + "preferences",
      stability: MODULE_PREFIX_GRIDS + "stability",
    }),
    colorVeryHigh() {
      return GRIDS_STABILITY_COLORS.veryhigh;
    },
    colorHigh() {
      return GRIDS_STABILITY_COLORS.high;
    },
    colorNeutral() {
      return GRIDS_STABILITY_COLORS.neutral;
    },
    colorLow() {
      return GRIDS_STABILITY_COLORS.low;
    },
    colorVeryLow() {
      return GRIDS_STABILITY_COLORS.verylow;
    },
  },
  methods: {
    toggleLevel(levelId) {
      let params = this.stability.params;
      params.levels = [];

      this.levels.forEach((level) => {
        if (levelId === level.id) {
          level.selected = !level.selected;
          this.handlePageTrackerEvent(
            EVENT_CATEGORIES.pulse_level,
            EVENT_ACTIONS.changed,
            levelId
          );
        }
        params.levels.push(level);
      });

      this.$store.dispatch(MODULE_PREFIX_GRIDS + GET_STABILITY_PARAMS, params);
      this.$store.dispatch(
        MODULE_PREFIX_GRIDS + GET_STABILITY_REFRESH_MAP,
        true
      );

      params = buildPreferences({
        preferences: this.preferences,
        levels: params.levels,
      });
      this.$store.dispatch(MODULE_PREFIX_USER + SAVE_PREFERENCES, params);
    },
    getPrefs() {
      this.levels = getLevelsFromPreferences(this.preferences);
    },
  },
  watch: {
    "stability.params": {
      handler() {
        if (this.stability.params && this.preferences) {
          this.levels = getLevelsFromPreferences(this.preferences);
        }
      },
      deep: true,
    },
  },
};
</script>

<style scoped>
.level-bar-container {
  display: grid;
  place-items: center;
}
</style>
